import {
  Agreement,
  AgreementsState,
  AgreementSwitcher,
  AgreementWaitingForContract,
  IHistoryData,
  TotalDebtAmountOnAllAgreementsByCurrency,
  WelcomeKisaStatus
} from './agreements.model';

const reducers = {
  storeWelcomeKisa: (state: AgreementsState, status: WelcomeKisaStatus) => ({
    ...state,
    welcomeKISA: status
  }),
  storeAllAgreements: (
    state: AgreementsState,
    agreements: Agreement[],
    totalDebtAmountOnAllAgreementsByCurrency: TotalDebtAmountOnAllAgreementsByCurrency
  ) => ({
    ...state,
    totalDebtAmountOnAllAgreementsByCurrency,
    agreements
  }),
  storeAgreementDetails: (
    state: AgreementsState,
    agreement: Agreement,
    agreementId: number
  ) => ({
    ...state,
    [agreementId]: agreement
  }),
  storeAgreementPayments: (
    state: AgreementsState,
    payments: IHistoryData[],
    agreementId: number
  ) => ({
    ...state,
    [agreementId]: {
      ...state[agreementId],
      details: {
        ...state[agreementId]?.details,
        payments
      }
    }
  }),

  storeAgreementsWaitingForContract: (
    state: AgreementsState,
    data: AgreementWaitingForContract[]
  ) => ({ ...state, agreementsWaitingForContract: data }),
  storeAgreementsWithProductAvailability: (
    state: AgreementsState,
    agreements: AgreementSwitcher[]
  ) => ({ ...state, agreementsWithProductAvailability: agreements })
};

export default reducers;
